"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IotsCodecError = exports.reporter = void 0;
const tslib_1 = require("tslib");
const io_ts_reporters_1 = tslib_1.__importDefault(require("@osdiab/io-ts-reporters"));
const ApplicationError_1 = require("./ApplicationError");
exports.reporter = io_ts_reporters_1.default.report;
class IotsCodecError extends ApplicationError_1.ApplicationError {
    constructor(errors) {
        super("Validation errors from io-ts codec", {
            errorMessages: io_ts_reporters_1.default.report(errors),
            errors: errors,
        });
    }
}
exports.IotsCodecError = IotsCodecError;
//# sourceMappingURL=IotsCodecError.js.map